import { rehydrateToken } from 'features/auth/slice';
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

/**
 
Initializes auth state from cookies on app load.
User data is automatically fetched by authListenerMiddleware when auth state changes.*/
const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(rehydrateToken());
  }, [dispatch]);

  return <>{children}</>;
};

export default AuthInitializer;
